import { Text, VStack } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../../../../features/track';
import { urlBuilder } from '../../../../../Shared/urlBuilder';

type Props = {
  legacyGoalId: number;
  name: string;
  isEditable: boolean;
};

export const PortfolioStrategyRow: React.FC<Props> = ({ legacyGoalId, name, isEditable }) => (
  <VStack>
    <Text variant="text200">{name}</Text>
    {isEditable && (
      <SambaAutoLink
        to={urlBuilder.appGoalsEditPortfolioStrategy.absolute({
          goalId: legacyGoalId,
          return_to: window.location.pathname,
        })}
        onClick={() => {
          trackClick({ name: 'ChangePortfolioStrategy', flow: 'AccountOverview', location: 'PortfolioStrategyCard' });
        }}
      >
        Change
      </SambaAutoLink>
    )}
  </VStack>
);
